<template>
  <div class="container">
    <!-- <div class="banner banner-gift" :class="{'mobile': !$mq.isDesktop()}">
      <span>
        PROMO BLACK WEEK: solo per questa settimana tutte le gift card scontate!
      </span>
    </div> -->
    <triangle-image
      :giftcard="!ctaDiscount"
      :giftcardDiscount="ctaDiscount"
      title="Scopri le Gift card Quomi"
      subtitle='Il regalo perfetto per stupire tutti in cucina'
    />

    <div >
      <div class="content">

        <template v-if="!showThankYouPage">

          <section>
            <div class="faq flex-stretch">
              <div class="usp">
                <div>
                  <img src="../assets/img/badges/gift/gift.png" class="usp-icon">

                </div>

                <div><b>Un regalo divertente e innovativo</b></div>

                <div>Le Gift Card Quomi sono perfette per regalare una nuova esperienza in cucina. In più sono facili da usare e sono valide sull'intera offerta del sito Quomi.</div>
              </div>

              <div class="usp">
                <div>
                  <img src="../assets/img/badges/gift/calendar.png" class="usp-icon">
                </div>

                <div><b>Senza vincoli</b></div>

                <div>Che sia un regalo per te o per i tuoi amici, potrai godere della totale flessibilità nell'utilizzo delle Gift Card Quomi. Senza vincoli e senza scadenza.</div>
              </div>

              <div class="usp">
                <div>
                  <img src="https://api.quomi.it/oldimg/new-product-%281%29.png" class="usp-icon">
                </div>

                <div><b>Sempre nuovo e sostenibile</b></div>

                <div>Stupisci ad ogni ordine con nuove ricette e prodotti della nostra bottega. In più con Quomi hai meno sprechi di cibo,  filiera corta, packaging riciclabile e un albero piantato ad ogni ordine!</div>
              </div>
            </div>
          </section>

          <section id="gift-section">
            <h2 >Scegli la tua Gift Card Quomi preferita!</h2>
            <p>Scegli la tipologia e la quantità che preferisci. Puoi regalarla ad amici o parenti o acquistarla per uso personale (NB se per uso personale inserisci i tuoi dati anche nella sezione del destinatario).<br> In più verrà piantato un albero per ogni ordine realizzato con le Gift Card!<br>
            </p>
            <!--<p>
              <b class="new-price">OFFERTA BLACK FRIDAY</b>: solo per questa ordine tutti i piani scontati. Approfittane ora!*<br>
              *Saranno utilizzabili senza scadenza dal 1 Dicembre 2020.
            </p>-->
            <!-- <div class="flex form">
              <div v-for="(plan, index) in basePrice" class="shadow-box box" :class=" { 'selected': plan.active }" @click="selectPeople(plan)" :key="index">
                <h2 v-html="breakWords(plan.name)"></h2>
                <div>({{ plan.people }} persone)</div>
                <div class="info-small-normal">2 ricette<br>per ordine</div>
              </div>
            </div> -->

            <!-- <div class="flex form">
              <div class="shadow-box box">
                <h2>Piano per coppia</h2>
                <div>(2 persone)</div>
                <div class="info-small-normal">2 ricette<br>per ordine</div>
              </div>
            </div> -->
            <h3>Seleziona la categoria che preferisci </h3>
            <div class="flex justify-content-around flex-wrap my-5">
              <div class="shadow-box cards" v-for="(panel, index) in config.panels" :key="index" @click="openOptions(panel.id)">
                <img :src="panel.img" loading="lazy" alt="card" class="w-100">
                <h2 class="text-body-small pt-2">{{panel.title}}</h2>
              </div>
            </div>

            <v-expansion-panels v-if="panel" id="options-panel">
              <v-expansion-panel>
                  <h2 class="mt-2" style="color: var(--quomi-color-text)">{{panelTitle}}</h2>
                  <p class="panel-description" v-html="panelDescription"></p>
                  <h3 style="color: var(--quomi-color-text)" v-if="panelId == 1">Scegli il numero di ricette per vedere le gift card disponibili</h3>
                  <div v-if="panelId == 1" style="max-width: 150px; margin: 0 auto" class="text-500">
                    <v-select
                      v-model="value"
                      placeholder="N° di ricette"
                      :items="meals"
                      item-text="label"  
                      item-value="value"
                    />
                  </div>
                  <div class="flex justify-content-center" :class="[!$mq.isDesktop() ? 'flex-wrap p-2' : 'form']"  v-if="panelId != 1 || value >= 2">
                    <div 
                    v-for="(q, index) in quantity" 
                    class="shadow-box box box-price"
                    :class="{'selected': q.active, 'mb-2 p-0' : !$mq.isDesktop()}" 
                    :key="index" 
                    style="height: fit-content"
                    :style="!$mq.isDesktop() ? 'width: 48%; margin: 0 2px' : ''"
                    >
                      <img :src="q.imgSrc" alt="gift logo" loading="lazy"  class="py-3" :style="!$mq.isDesktop() ? 'width: 90%' : 'width: 90%'" />
                      <div class="q-name mx-1 mb-5">
                        <span class="pb-3 text-bold" style="color: var(--quomi-color-text)">{{ q.name }}</span>
                        <div class="flex flex-column" v-if="panelId == 1">
                          <span>da {{value}} ricette</span>
                          <span>per {{q.people}} persone</span>
                        </div>
                      </div>
                      <section-toggle :giftcard="true" :trigger.sync="q.index" v-if="panelId != 1 && panelId != 5" >
                        <template slot="gift"/>
  
                        <template slot="content">
                          <div class="section-ingredients m-auto" :style="$mq.isDesktop() ? 'width: 195px' : 'width: 95%'">
                            <SliderQ
                              :maxNumSlides="3"
                              :minSizeOfSlide="100"
                              isCentered
                            >
                              <slide
                                v-for="(ingredient, index) in q.ingredients"
                                :key="index"
                                class="px-1 pb-3"
                              >
                                <div>
                                  <img :src="ingredient.img"  style="border-radius: 50%; width: 50px; height: 45px" />
                                </div>
                                <div
                                class="mt-1"
                                style="font-size: 10px"
                                v-html="ingredient.name"
                                />
                              </slide>
                            </SliderQ>
                          </div>
                        </template>

                      </section-toggle>

                      <h2>
                        <nobr>
                          <div class="tonew-pricet-price">
                            <div class="new-price" v-if="q.discount > 0">
                                {{ q.price *(100-q.discount)/100 | priceFilter}}
                                <small>
                                  <span style="color: red">- {{q.discount}}%</span> | 
                                  <span class="text-muted text-decoration-line-through">{{q.price | priceFilter }}</span>
                                </small>
                            </div>
                            <div v-else>
                              {{ q.price | priceFilter }}
                            </div>
                          </div>              
                        </nobr>
                      </h2>

                      <CTA
                        style="width: 85%; margin: 15px auto 0 auto"
                        :color="q.active ? `green` : `orange`"
                        :content="q.active ? `Selezionato` : `Seleziona`"
                        @click="selectQuantity(q)"
                      />
                      <br>
                    </div>
                  </div>
              </v-expansion-panel>
            </v-expansion-panels>



            <!-- <div class="flex form" :class="{'flex-wrap' : !$mq.isDesktop()}">
              <div v-for="(q, index) in quantity" class="shadow-box box box-price" :class="{'selected': q.active}" @click="selectQuantity(q)" :key="index">
                <div class="q-name">{{ q.name }}</div>
                <h2><nobr>
                        <div class="tot-price">
                           <div class="new-price" v-if="q.discount > 0">
                              {{ (price * q.weeks)*(100-q.discount)/100 | priceFilter}}
                            </div>
                            <div v-else>
                              {{ price * q.weeks | priceFilter }}
                            </div>
                        </div>

                        
                        </nobr></h2>
                  
                        <div class='old-price' v-if="q.discount > 0">
                          invece di <br><span class="strike">{{ price * q.weeks | priceFilter}}</span>
                        </div><br>
                        <div v-if="q.discount > 0" >
                          <div v-if="q.weeks == 1">
                            Sconto del <br>10%
                          </div>
                          <div v-if="q.weeks == 2">
                            Sconto del <br>15%
                          </div>
                          <div v-if="q.weeks == 4">
                            Sconto del <br>20%
                          </div>
                          <div v-if="q.weeks == 8" class="gift-wow">
                            2 ordini <br>in regalo!
                          </div>
                      </div>
              </div>
            </div> -->
          </section>

          <section id="recipient" v-show="openedRecipient">
            <div class="sidebar-panel_inner">
              <h3>A chi desideri fare il regalo?</h3>
              <p>Penseremo noi ad inviargli una mail dedicata con il codice e il tuo messaggio.</p>
              <form>
                <input type="text" name="name" class="form-control" v-model="form.recipient_name" placeholder="Nome destinatario" autocomplete="off">

                <input type="email" name="email" class="form-control" v-model="form.recipient_email" placeholder="Email destinatario" required :class="{'border-red': state === 'error' && !form.recipient_email}"  autocomplete="off">

                <textarea rows="10" name="message" class="form-control" v-model="form.message"
                  placeholder="Aggiungi il tuo messaggio, emoziona con le tue parole!"
                  value="" autocomplete="off"></textarea>
              </form>
            </div>
          </section>

          <section>
            <div v-show="openedRecipient">
              <h3>Firma il regalo!</h3>
              <p>Inserisci gli ultimi dati per concludere il tuo acquisto</p>
              <form v-if="v_user">
                <input type="text" name="name" class="form-control" placeholder="Il tuo nome" v-model="v_user.fullname"  autocomplete="name">

                <input type="email" name="email" class="form-control" placeholder="La tua mail" required :class="{'border-red': state === 'error' && !v_user.email }" v-model="v_user.email" autocomplete="email">
              </form>
            </div>

            <form v-show="openedRecipient">
              <h3>Dati di pagamento</h3>

              <div id="credit-card">

                <div style='background: white;padding:20px' ><div id="setup-form">
                  <div id="payment-element"></div>
                </div>

              </div>
              <br><br>
              </div>

              <label class="mb-5">
                <input name="conditions" id="conditions-checkbox" type="checkbox" v-model="checked"> Accetto le <router-link :to="{name: 'legal'}" class="link-detail" title="Condizioni generali di vendita" target="_blank">condizioni generali di vendita</router-link> e la <router-link :to="{name: 'privacy-policy'}" class="link-detail" title="Privacy policy" target="_blank">privacy policy</router-link> di Quomi
              </label>

              <div class="sidebar-panel_inner">
                <div v-if="panelId == 1">
                  <div class="flex" v-show="mealsBoxName">
                    <div>Prodotto:</div>
                    <div class="flex-right">{{mealsBoxName}} Ricette</div>
                  </div>

                  <div class="flex" v-show="value">
                    <div>N. ricette:</div>
                    <div class="flex-right">{{ value }} ricette</div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex" v-show="extraName">
                    <div v-if="panelId == 5">Valore gift card: </div>
                    <div v-else>Prodotto:</div>
                    <div v-if="panelId == 5" class="flex-right">{{price | priceFilter}}</div>
                    <div v-else class="flex-right">{{extraName}}</div>
                  </div>
                </div>
              

                <div class="flex">
                  <div><b>Totale da pagare:</b></div>
                  <div class="flex-right" v-if="totalPrice"><b>{{ totalPrice | priceFilter}}</b></div>
                  <div class="flex-right" v-else><b>0.00</b></div>
                </div>
              </div>

              <div class='error form-group hide'>
                <div class='alert-danger alert'>Please correct the errors and try again.</div>
              </div>

            </form>

            <div> 
              <CTA
                isWithLoader
                :loading="loading"
                v-show="openedRecipient"
                class="mt-5 m-auto"
                :size="`big`"
                :content="`Conferma ordine`"
                @click="send()"
                :disabled="disabled"
              />
              <i class="fa fa-lock pt-5"></i> Transazione sicura
              <br>

              <div class="flash" :class="{'success': state === 'success', 'error': state === 'error'}">{{ flash }}</div>

              <br>

              <div>
                <img src="../assets/img/content/carte.jpg" alt="carte di credito">
                <img src="../assets/img/ssl.png" alt="ssl" width="100px">
              </div>

              <div class="faq-section mt-10">
                <h2 class="m-0">Domande frequenti</h2>
                <faqPage :giftCardPage="true"/>
              </div>

            </div>

          </section>
        </template>

        <template v-if="showThankYouPage">

          <section id="thank-you">

            <p><i class="fa fa-heart fa-4x" aria-hidden="true" style="color: #f25f5c"></i></p>
            <h2>Grazie per aver scelto la qualità di Quomi</h2>

            <p>Riceverai a breve la conferma di pagamento sulla tua mail. La Gift Card sarà inviata alla mail da te indicata.</p>
            <p>Ci vediamo in cucina!</p>

          </section>

        </template>
      </div>

    </div>
  </div>
</template>

<script>
import { scrollToTop } from '../assets/js/main.js'
import { scrollToElementId } from '../assets/js/main'
import { PaymentApi } from '../api/PaymentApi'
import { Utils } from '../assets/utils/utils'
import TriangleImage from '@/components/TriangleImage'
import { Card } from 'vue-stripe-elements-plus'
import { stepPaymentStore } from '../store/stepPaymentStore'
import { plansStore } from '../store/plansStore' 
import { ExtraApi } from '../api/ExtraApi'
import SectionToggle from './Parts/SectionToggle'
import FaqPage from './FaqPage'

export default {
  components: {
    'triangle-image': TriangleImage,
    Card,
    SectionToggle,
    FaqPage
  },

  data () {
    return {
      loading: false,
      panel: false,
      items: 1,
      checked: false,
      panelId: null,
      panelTitle: '',
      panelDescription: '',
      giftImage: '',
      showThankYouPage: false,
      people: 2,
      price: null,
      meals: [],
      value: null,
      default: 2,
      extras: [],
      targetExtra: [],
      mealsBoxName: '',
      extraName: '',
      openedRecipient: false,
      week: 1, // default week
      discount: 0, // default discount
      title: 'Piano Coppia', // default title
      ctaDiscount: false,
      months: new Utils().getCreditCardMonths(),
      years: new Utils().getCreditCardYears(),

      /* basePrice: [
        { name: 'Piano Coppia', price: 34.90, people: 2, active: true },
        { name: 'Piano Famiglia', price: 48, people: 4, active: false }
      ], */

      quantity: [
        { name: '1 ordine', people: 2 , active: false, discount: 0, imgSrc: '', ingredients: [], price: 0, weeks: 1},
        { name: '2 ordini', people: 4 , active: false, discount: 0, imgSrc: '', ingredients: [], price: 0, weeks: 2},
        { name: '4 ordini', people: 6 , active: false, discount: 0, imgSrc: '', ingredients: [], price: 0, weeks: 4},
        { name: '8 ordini', people: 8 , active: false, discount: 0, imgSrc: '', ingredients: [], price: 0, weeks: 8}
      ],

      cc: { number: '', cvv: '', month: '', year: '', name: '' },

      form: { message: '', recipient_email: '', recipient_name: '' },

      flash: '',
      state: null,

      v_user: null,

      stripeConfig: stepPaymentStore.config.stripe
    }
  },

  watch: {
    value(newValue) {
      if(newValue) {
        this.setMealsPrices(newValue)
      }
    }
  },

  computed: {
    totalPrice () {
      let totalPrice = null
      if(this.panelId == 1) {
        totalPrice = this.price * this.week * (100-this.discount)/100
      }else {
        totalPrice = this.basicPrice * (100-this.discount)/100
      }
      return totalPrice

    },

    basicPrice () {
      return this.price;
    },

    disabled () {
      return !this.checked || this.loading
    },

    user () {
      return this.$root.user
    },
    config () {
      return this.$route.meta.config
    },
    labelTitle() {
      switch(this.panelId) {
        case 1:
          return this.mealsBoxName;
        case 5: 
          return 'Importo gift card';
        default: 
          return this.extraName
      }
    },
    labelImg() {
      switch(this.panelId) {
        case 1:
          return 'https://api.quomi.it/oldimg/box-ricette-gift-card-quomi.webp';
        case 5: 
          return 'https://api.quomi.it/oldimg/gift_card_quomi.png';
        default: 
          return this.giftImage
      }
    }
  },

  methods: {
    breakWords (string) {
      return string.replace(/\s+/g, '<br>')
    },

    initial () {
      this.v_user = this.user && !this.user.email.includes('guest.quomi.it')
        ? this.user
        : { email: '', firstname: '', lastname: '', fullname: '' }
      if (!this.v_user.firstname || !this.v_user.lastname) return
      this.v_user.fullname = this.v_user.firstname + ' ' + this.v_user.lastname
    },

    /* selectPeople (plan) {
      this.basePrice.forEach(p => { p.active = false })
      plan.active = true
      this.price = plan.price
      this.title = plan.name
      this.people = plan.people
    }, */

    selectQuantity (q) {
      this.quantity.forEach(p => { p.active = false })
      this.discount = q.discount
      
      if(this.panelId == 1) {
        this.price = q.price
        this.mealsBoxName = q.name
        q.active = true
      }else {
        this.extraName = q.name
        this.price = q.price
        this.giftImage = q.imgSrc
        q.active = true
      }
      this.toGiftRecipient()
    },

    send () {
      this.flash = null
      this.loading = true

      var params = {
        amount: this.totalPrice,
        weeks: this.week,
        message: this.form.message,
        title: this.title,
        item_title: this.labelTitle,
        item_img: this.labelImg,
        basic_price: this.basicPrice,
        people: this.people,
        sender_email: this.v_user.email,
        sender_name: this.v_user.fullname,
        recipient_email: this.form.recipient_email,
        recipient_name: this.form.recipient_name
      }



      var req = ['recipient_email', 'sender_email']

      var missingField = req.filter(r => !params[r])
      if (missingField.length > 0) {
        this.flash = ''
        missingField.forEach(field => { this.flash = 'Mancano le informazioni nei campi obbligatori' })
        this.state = 'error'
        this.loading = false
        return
      }

      var pm = new PaymentApi()
      var cus;
      return pm.intentGuestStripe({
        email: this.v_user.email
      }).then(response => {
        cus = response.body.data.customer;
        return this.stripe.confirmCardSetup(
          response.body.data.client_secret,
          {
            payment_method: {
              card: this.cardElement,
              billing_details: {
                name: this.v_user.email,
              },
            },
          }
        )
      }).then(result => {

        if (result.error) {
          this.state = 'error'
          this.flash = result.error.message
          throw result.error
        } else {
          if (result.setupIntent.status !== 'succeeded') {
            this.state = 'error'
            this.flash = "errore, riprova"
            //this.flash = {'message': result.setupIntent}
            throw {'message': result.setupIntent.status}
          }
        }
        return result
      }).then(response => {
        params.intent = response.setupIntent.id
        params.cus = cus;

        return pm.gift(params).then(response => {
          this.flash = 'Grazie! Il pagamento è andato a buon fine. Riceverai a breve una mail di conferma'
          this.loading = false

          this.cc = { number: '', cvv: '', month: '', year: '', name: '' } // clear form after payment

          this.checked = false
          this.showThankYouPage = true
          this.state = 'success'
          scrollToTop()

        })
        
      }).catch(response => {
        if (response.body) {
          this.flash = response.body.message ? this.$t(response.body.message) : 'Il pagamento non è andato a buon fine'
        }
        this.state = 'error'
        this.loading = false
      }) 
      
    },

    resetData() {
      this.panel = true
      this.value = null
      this.price = null
      this.mealsBoxName = ''
      this.extraName = ''
    },

    openOptions (id) {
      this.openedRecipient = true
      this.resetData()
      if(!this.$mq.isDesktop()) {
        setTimeout(this.toPanel, 100)
      }
      this.setPanel(id, false)
    },

    toPanel() {
      scrollToElementId('options-panel')
    },

    toGiftRecipient() {
      scrollToElementId('recipient')
    },

    setMealsPrices(newValue) {
      let target = this.config.panels.find(panel => panel.id === 1)
      let getPrice = target.defaultPrice.find(price => price.value == newValue)

      this.quantity.map((el,index) => {
        let people = el.people
        let finalPrice = getPrice.price.find(el => el.people == people)
        el.active = false
        el.price = finalPrice.total
        })

    },

    setPanel(id, param) {
      let target = this.config.panels.find(panel => panel.id === id)
      let products = target.products
      
      if(products) {
        products.map(el => this.targetExtra.push(el.extraId))
      }

      this.panelId = id
      this.panelTitle = target.panelTitle
      this.panelDescription = target.panelDescription
      

      this.quantity.map((el, index) => {  //set cards names & images based on panel id
      el.active = param
      el.name = target.cardName
      el.imgSrc = target.giftImage
      if(target.discount > 0) el.discount = target.discount

      if(target.prices) {
        let setPrice = target.prices.find(price => price.value == index)
        el.price =  setPrice.price
      }
      
      if (this.panelId == 1) { //settings for first card
        el.name = target.cardName
      }else if (this.panelId != 1 && this.panelId != 5) { // settings and ingredients section for extras boxes/cocktails
        let getCard = products.find(el => el.id == index) 
        let extra = this.extras.find(extra => getCard.extraId === extra.id)
        if (extra) {
          extra.ingredients.map(item => el.ingredients.push({name: item.name, img: item.images.small})) //populate the ingredients slider
          if(el.ingredients.length) {
            el.ingredients = []
            extra.ingredients.map(item => el.ingredients.push({name: item.name, img: item.images.small}))
          }
          el.name = extra.name
          el.imgSrc = extra.images.small
        }
      }
      })
    },
  
    filterMeals() {
      for(let i = 2; i <= 4; i++) {
        this.meals.push({value: i, label: `${i} ricette`})
      }
    },

    loadExtras () {
			var em = new ExtraApi()
			return em.all({
				params: {
					show: 12,
					page: 1,
					sort_direction: 'asc',
          productables: true,
					query: 'id in (4143,4144,4147,5647,4146,4149,3445,3097,3932,3722,4973,3217,3219,4137)'
				}
			}).then(response => {
				this.extras = response.body.data.resources
			}).catch(response => {
			})
		}
  },

  mounted () {
    this.initial()  
    this.loadExtras()
    this.filterMeals()
    this.stripe = Stripe(this.stripeConfig.options.key, {locale: 'it'});
    this.elements = this.stripe.elements();
    this.cardElement = this.elements.create('card', this.stripeConfig.options);
    this.cardElement.mount('#payment-element');
    if(this.config.panels.some(el => el.discount > 0)) {
      this.ctaDiscount = true
    }
  },

  created() {
     window.addEventListener('scroll-to-recipient', () => scrollToElementId('gift-section'))
  },

  destroyed() {
     window.removeEventListener('scroll-to-recipient', () => scrollToElementId('gift-section'))
  },
}

</script>

<style scoped>
h2,h3 {
  text-align: center;
}
.container {
  min-height: 200px;
}

.content {
  max-width: 1024px;
  text-align: center;
  padding: 0px 15px 30px 15px;
}

.usp {
  border: none;
  flex-grow: 1;
  max-width: 100%;
  min-width: 260px;
  flex-basis: calc(100% / 3 - 60px);
  text-align: center;
}

.usp > div {
  box-sizing: border-box;
  padding-top: 10px;
}

.triangle-image {
  background-image: url("../assets/img/covers/san-valentino.jpg");
  /*background-image: url("https://api.quomi.it/oldimg/natale-quomi-header-aziende.webp");*/
  background-position: 50% 50%;
}

section + section {
  border-top: 1px solid #d4d1d1;
  padding: 40px 0 20px 0;
  margin-top: 20px;
}

.section-ingredients >>> .slider-arrow {
    top: 10px;
		background-color: unset;
}

.section-ingredients >>> .slider-arrow.next {
    margin-right: -3px;
}

.section-ingredients >>> .slider-arrow.prev {
    margin-left: -3px;
}

section .form,
section form {
  max-width: 100%;
  margin: 0 auto;
}

.flex.form > div{
  margin: 10px;
  flex-basis: calc(100% - 20px);
}

.flex.form + .flex.form {
  margin-top: 10px;
}

form + form {
  margin-top: 20px;
}

[name="cvc"] {
  max-width: 80px;
}

.box {
  border: 2px solid #ededed;
  border-radius: 10px;
  cursor: pointer;
}

.box.selected {
  border-color: #9fcb00;
}

.total-payment {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.border-red {
  border-color: rgba(255, 133, 133, 0.57) !important;
}

.usp-icon {
  max-width: 60px;
}

.sidebar-panel_inner {
  border-radius: 6px;
  background-color: #fbf1d7;
  padding: 25px;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
}

#conditions-checkbox {
  cursor: pointer;
  width: 20px;
  vertical-align: middle;
  margin-bottom: 1px;
  transform: scale(1.4);
}

label {
  cursor: pointer;
}

.box-price {
  min-height: 370px;
  display: flex;
  flex-direction: column;
  justify-content: space-between !important;
  max-height: fit-content !important;
}

.box-price img {
  align-self: center;
}

.tot-price {
  color: var(--quomi-color-text);
}

.cards{
  width: 190px;
}

.cards:hover {
  box-shadow: rgba(0, 0, 0, 0.22) 0px 19px 43px;
  transform: translate3d(0px, -1px, 0px);
  cursor: pointer;
}

.new-price {
  display: flex;
  flex-direction: column;
}

@media (min-width: 800px) {
  .q-name {
    height: 55px;
    font-size: 1em;
  }

  .panel-description {
  padding: 0 16%;
  }
}

@media (max-width: 800px) {
  .flex.form > div[data-v-4c8d9ee0] {
    margin: 5px;
    flex-basis: calc(100% - 10px);
  }

  .q-name {
    font-size: 13px;
    text-align: left;
    padding-left: 5px;
  }

  .box {
    padding: 20px 5px;
    color: var(--quomi-color-text);
  }

  .box h2 {
    margin-bottom: 0;
  }

  .cards{
    width: 45%;
    margin: 10px auto;
  }

  .cards h2 {
    font-size: 12px !important;
  }

}
.error {
  color: red;
}

/*
.gift-wow {
  color: red;
  animation: example 2s infinite;
}

@keyframes example {
  0%   {color: red;font-size:12px;}
  25%  {color: yellow;font-size:14px;}
  50%  {color: blue;font-size:12px;}
  100% {color: green;font-size: 14px;}
}*/

.gift-wow {
  font-weight: bold;
  color: var(--quomi-primary);
}




.banner {
  top: 80px;
  width: 100%;
  z-index: 3;
  padding: 4px 0;
  font-size: 15px;
  text-align: center;
  position: absolute;
  transition: all 0.8s ease;
}

@media (max-width: 1024px) {
  .banner {
    top: 50px;
  }
}

.banner-gift {
  font-weight: bold;
  color: white;
  background-color: black;
}

@media (max-width: 425px) {
  .cards h2 {
    font-size: 9px !important;
  }

  .panel-description {
  padding: 0 5%;
}
.triangle-image {
  /*background-image: url("../assets/img/covers/san-valentino.jpg");*/
  background-image: url("https://api.quomi.it/oldimg/cover-box-mobile-gift-natale-quomi.webp");
  background-position: 50% 50%;
}
}
</style>

<style>
.v-text-field input::placeholder {
    font-weight: 600;
}
</style>
